import { useState } from "react";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import 'quill/dist/quill.snow.css'
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from "../../../../../../../Helpers/apiConfig";

export const AdminCreateBySortId = () => {
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams()

    const navigate = useNavigate();

    const questionTypes =
        [
            {
                "id": 1,
                "name": "video",
                "description": "Eğitim videosu ",
            },
            {
                "id": 2,
                "name": "choice",
                "description": "çoktan seçmeli /şıklı sorular için",
            },
            {
                "id": 3,
                "name": "UNSCREABLE",
                "description": "harflerden kelime/kelimelerden cümle",
            },
            {
                "id": 4,
                "name": "write",
                "description": "yazma",
            },
            {
                "id": 5,
                "name": "trueFalse",
                "description": "doğru yanlış",
            },
            {
                "id": 6,
                "name": "match",
                "description": "Toplu Eşleştirme / yazı yazı/resim resim drag-drop vb.",
            },
            {
                "id": 7,
                "name": "sentence",
                "description": "cümle içinde boş bırakılan yerdeki kelimeleri seçme",
            },
            {
                "id": 8,
                "name": "link",
                "description": "Link aktivite sorusu",
            }
        ];

    const onSubmit = async (e) => {
        try {
            let questiontype = await document.getElementById("contentType").value;
            navigate("/admin/updatequestiondetail/" + params['subjectId'] + "/" + questiontype + "/" + params['id']);
        } catch (error) {
            alert(error.message);
        }

    }

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>Soruyu Yeniden Oluşturma</h1>
            </div>
            <h4>{msg}</h4>

            <form onSubmit={onSubmit} >
                {/*<div class="mb-3">
                    <label for="courseId" class="form-label">{t("selectCourse")}</label>
                    <select id="courseId" class="form-select" onChange={realonChange}>
                        <option key="" >{t("selectCourse")}</option>

                        {courses ? (
                            courses && courses.map((dt) => {
                                return (
                                    <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                );
                            })
                        ) : (
                            <p>{t("reloadWarning")}</p>
                        )
                        }
                    </select>
                </div>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div class="mb-3">
                        <label for="subjectId" class="form-label">{t("selectSubject")}</label>
                        <select id="subjectId" class="form-select" >
                            <option key="" >{t("selectSubject")}</option>

                            {subjects ? (
                                subjects && subjects.map((dt) => {
                                    return (
                                        <option key={dt.id} value={dt.id}>{dt.subjectName} // {dt.subjectDesc}</option>
                                    );
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>


                )} */}


                <div class="mb-3">
                    <label for="contentType" class="form-label">{t("selectQuestionType")}</label>
                    <select id="contentType" class="form-select">
                        <option key="0" value={0}>{t('selectQuestionType')}</option>
                        {questionTypes ? (
                            questionTypes && questionTypes.map((dt) => {
                                return (
                                    <option key={dt.id} value={dt.id}>{dt.name} - {dt.description}</option>
                                );
                            })
                        ) : (
                            <p>{t("reloadWarning")}</p>
                        )
                        }
                    </select>
                </div>

                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg">{t("startToCreate")}</button>
                </div>

            </form>


        </div >

    )
}
export default AdminCreateBySortId;



